import './app.css';
import { mount } from 'svelte';
import App from './App.svelte';

// Import test utilities for development
if (import.meta.env.VITE_ENVIRONMENT === 'development') {
  import('./utils/test-api').then(({ testApiIntegration }) => {
    (window as any).testApiIntegration = testApiIntegration;
    console.log('🧪 API test function available: testApiIntegration()');
  });
}

const app = mount(App, {
  target: document.getElementById('app')!
});

export default app;
